import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section brand">
            <h3 className="footer-logo">FINNCAL</h3>
            <p className="footer-tagline">Life on Your Terms</p>
            <p className="footer-description">
              Financial freedom planning for India. Research-backed, completely free.
            </p>
            {/* Social Media Links */}
            <div
              className="social-links"
              style={{ marginTop: '16px', display: 'flex', gap: '16px', alignItems: 'center' }}
            >
              <a
                href="https://www.linkedin.com/company/111393004"
                target="_blank"
                rel="noopener noreferrer"
                title="LinkedIn"
                style={{
                  color: 'var(--text-secondary)',
                  fontSize: '1.1rem',
                  textDecoration: 'none',
                  opacity: 0.8,
                  transition: 'opacity 0.2s',
                }}
                onMouseOver={(e) => (e.target.style.opacity = 1)}
                onMouseOut={(e) => (e.target.style.opacity = 0.8)}
              >
                in
              </a>
              <a
                href="https://youtube.com/@finncalfr"
                target="_blank"
                rel="noopener noreferrer"
                title="YouTube"
                style={{
                  color: 'var(--text-secondary)',
                  fontSize: '1.2rem',
                  textDecoration: 'none',
                  opacity: 0.8,
                  transition: 'opacity 0.2s',
                }}
                onMouseOver={(e) => (e.target.style.opacity = 1)}
                onMouseOut={(e) => (e.target.style.opacity = 0.8)}
              >
                ▶
              </a>
              <a
                href="https://x.com/Finncalindia"
                target="_blank"
                rel="noopener noreferrer"
                title="X (Twitter)"
                style={{
                  color: 'var(--text-secondary)',
                  fontSize: '1.1rem',
                  textDecoration: 'none',
                  opacity: 0.8,
                  transition: 'opacity 0.2s',
                }}
                onMouseOver={(e) => (e.target.style.opacity = 1)}
                onMouseOut={(e) => (e.target.style.opacity = 0.8)}
              >
                𝕏
              </a>
              <a
                href="https://instagram.com/finncalfr"
                target="_blank"
                rel="noopener noreferrer"
                title="Instagram"
                style={{
                  color: 'var(--text-secondary)',
                  fontSize: '1.1rem',
                  textDecoration: 'none',
                  opacity: 0.8,
                  transition: 'opacity 0.2s',
                }}
                onMouseOver={(e) => (e.target.style.opacity = 1)}
                onMouseOut={(e) => (e.target.style.opacity = 0.8)}
              >
                📷
              </a>
            </div>
          </div>

          {/* Tools Section */}
          <div className="footer-section">
            <h4>Tools</h4>
            <ul className="footer-links">
              <li>
                <Link to="/tools/freedom-number">Comprehensive Calculator</Link>
              </li>
              <li>
                <Link to="/tools/corpus-optimizer">Corpus Optimizer</Link>
              </li>
              <li>
                <Link to="/tools/stress-test">Stress Test</Link>
              </li>
              <li>
                <Link to="/tools/reverse-mortgage">Reverse Mortgage</Link>
              </li>
              <li>
                <Link to="/tools/relocation">Plan B (Relocation)</Link>
              </li>
            </ul>
          </div>

          {/* Explore Section */}
          <div className="footer-section">
            <h4>Explore</h4>
            <ul className="footer-links">
              <li>
                <Link to="/city-finder">City Finder</Link>
              </li>
              <li>
                <Link to="/learn">Learn</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Resources Section - Links to Learn page */}
          <div className="footer-section">
            <h4>Resources</h4>
            <ul className="footer-links">
              <li>
                <Link to="/learn">Understanding FIRE</Link>
              </li>
              <li>
                <Link to="/learn">Safe Withdrawal Rates</Link>
              </li>
              <li>
                <Link to="/learn">Planning Guides</Link>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div className="footer-section">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms of Service</Link>
              </li>
              <li>
                <Link to="/disclaimer">Disclaimer</Link>
              </li>
            </ul>
            <div
              className="grievance-contact"
              style={{ marginTop: '12px', fontSize: '0.85rem', color: 'var(--text-secondary)' }}
            >
              <p style={{ margin: '0 0 4px 0' }}>Contact / Grievance:</p>
              <a
                href="mailto:freedom@finncal.com"
                style={{ color: 'var(--primary)', textDecoration: 'none' }}
              >
                freedom@finncal.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>&copy; {currentYear} FINNCAL. All rights reserved.</p>
          <p className="footer-disclaimer">
            For educational purposes only. Not financial advice. Consult a qualified advisor.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
